import React from "react";

export default function IconReplay(props) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3232 6.19568C11.6034 6.34467 11.8377 6.56708 12.0012 6.83909C12.1646 7.11109 12.2509 7.42244 12.2509 7.73976C12.2509 8.05709 12.1646 8.36843 12.0012 8.64044C11.8377 8.91244 11.6034 9.13486 11.3232 9.28385L3.84955 13.3479C2.64614 14.0024 1.16797 13.1508 1.16797 11.8044V3.67568C1.16797 2.32818 2.64614 1.4771 3.84955 2.13101L11.3232 6.19568Z"
        fill="white"
      />
    </svg>
  );
}
